// extracted by mini-css-extract-plugin
export default {"services":"subscriptions_services__NEUmI","container":"subscriptions_container__3-cIb"};